import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  Signal,
  ViewChild,
  ViewEncapsulation,
  WritableSignal
} from '@angular/core';
import { ExerciseTemplateDto } from '@therapist/shared/models/exercise/exercise-template.dto';
import { Button } from 'primeng/button';
import { Message } from 'primeng/message';
import { Tooltip } from 'primeng/tooltip';
import { ExerciseActivityBadgeComponent } from '../exercise-activity-badge/exercise-activity-badge.component';
import { JointBadgeComponent } from '../joint-badge/joint-badge.component';
import { Select, SelectChangeEvent } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TherapistVideoViewerComponent } from '../therapist-video-viewer/therapist-video-viewer.component';

@Component({
  selector: 'sana-tp-exercise-template-list',
  imports: [
    Button,
    Message,
    Tooltip,
    ExerciseActivityBadgeComponent,
    JointBadgeComponent,
    Select,
    FormsModule,
    TherapistVideoViewerComponent
  ],
  templateUrl: './exercise-template-add-list.component.html',
  styleUrl: './exercise-template-add-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ExerciseTemplateAddListComponent implements OnInit, AfterViewInit {

  @HostListener('window:resize')
  onResize() {
    this.adjustContainerHeight();
  }

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  @Input({ required: true }) allTemplateExerciseList!: Signal<ExerciseTemplateDto[] | null>;
  @Input({ required: true }) selectedTemplateExerciseList!: Signal<ExerciseTemplateDto[] | null>;
  @Input({ required: true }) clientId!: string;

  @Output() addExercise = new EventEmitter<ExerciseTemplateDto>();
  @Output() removeExercise = new EventEmitter<ExerciseTemplateDto>();

  readonly #cdRef = inject(ChangeDetectorRef);

  containerHeight = 0;
  exercisePlayingId: WritableSignal<string | null> = signal(null);

  selectedExerciseVariant: Record<string, string> = {};

  ngOnInit() {
    this.allTemplateExerciseList()!
      .filter(exerciseTemplates => exerciseTemplates.variants.length > 0)
      .forEach((exerciseTemplate) => {
        if (this.isExerciseAlreadySelected(exerciseTemplate)) {
          this.selectedExerciseVariant[exerciseTemplate.aggregateId!] = this.selectedTemplateExerciseList()!.find(selected => selected.aggregateId === exerciseTemplate.aggregateId)!.id;
        } else {
          this.selectedExerciseVariant[exerciseTemplate.aggregateId!] = exerciseTemplate.variants[0].id;
        }

      });
  }

  ngAfterViewInit() {
    this.adjustContainerHeight();
  }

  adjustContainerHeight() {
    const offsetTop = 210;
    const offsetBottom = 96;
    this.containerHeight = window.innerHeight - offsetTop - offsetBottom;
    this.#cdRef.detectChanges();
  }

  addToTherapyPlan(exercise: ExerciseTemplateDto): void {
    if (exercise.variants.length > 0) {
      const variant = exercise.variants.find(exercise => exercise.id === this.selectedExerciseVariant[exercise.aggregateId!])!;
      this.addExercise.emit(variant);
    } else {
      this.addExercise.emit(exercise);
    }
  }

  removeFromTherapyPlan(exercise: ExerciseTemplateDto): void {
    if (exercise.variants.length > 0) {
      const variant = exercise.variants.find(exercise => exercise.id === this.selectedExerciseVariant[exercise.aggregateId!])!;
      this.removeExercise.emit(variant);
    } else {
      this.removeExercise.emit(exercise);
    }
  }

  isExerciseAlreadySelected(exercise: ExerciseTemplateDto): boolean {
    return this.selectedTemplateExerciseList()!.some(e => e.aggregateId === exercise.aggregateId);
  }

  variantSelectionChanged($event: SelectChangeEvent): void {
    const value = $event.value as ExerciseTemplateDto;
    this.selectedExerciseVariant[(value.aggregateId)!] = value.id;
  }
}
